import React from 'react';
export function Footer() {
  return <footer className="bg-black px-5 py-10 text-center sm:px-8" data-id="element-60" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-3xl space-y-3 text-[12px] leading-relaxed text-neutral-400" data-id="element-61" data-mp="3gfiv8kpoaff6">
        <p className="font-display text-[15px] text-neutral-200" data-id="element-62" data-mp="32oe0nx15wdbp">
          Manual de Autosanación Energética
        </p>
        <nav className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1" data-id="element-63" data-mp="36q92d2n08sq0">
          <a href="#privacidad" className="transition-colors duration-200 ease-out hover:text-gold" data-id="element-64" data-mp="3ues7xaeo6ree">
            Política de Privacidad
          </a>
          <span aria-hidden="true" className="text-neutral-700" data-id="element-65" data-mp="36d2ywbrgrms">|</span>
          <a href="#terminos" className="transition-colors duration-200 ease-out hover:text-gold" data-id="element-66" data-mp="3ldu4ouc22nwv">
            Términos
          </a>
          <span aria-hidden="true" className="text-neutral-700" data-id="element-67" data-mp="3qf9nsguoakcm">|</span>
          <a href="#contacto" className="transition-colors duration-200 ease-out hover:text-gold" data-id="element-68" data-mp="29xvps9u757nq">
            Contacto
          </a>
        </nav>
        <p className="text-neutral-500" data-id="element-69" data-mp="3l9ahbtogro9p">
          Producto educativo e informativo. No sustituye diagnóstico ni tratamiento médico
          profesional. Los resultados individuales pueden variar.
        </p>
        <p className="text-neutral-600" data-id="element-70" data-mp="3v7zxni0pp0nu">© 2025 Todos los derechos reservados.</p>
      </div>
    </footer>;
}